import PersonIcon from "@mui/icons-material/Person";
import { Card, CardContent, Rating, Stack, Typography } from "@mui/material";

import { ISOStringToReadableDate } from "../../utils";

interface Props {
  text: string | undefined;
  rating: number;
  author: string;
  createdAt: string;
  authorCompany?: string;
}

export function CompanyReview(props: Props) {
  const { text, rating, author, createdAt, authorCompany = "" } = props;
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={1}>
          <Stack direction="row" spacing={1} alignItems="center">
            <PersonIcon fontSize="large" />
            <Stack direction="column">
              <Typography variant="body1">{author}</Typography>
              <Typography variant="body1" color="text.secondary">
                {authorCompany}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <Rating readOnly value={rating} />
            <Typography variant="body1" color="text.secondary">
              Submitted {ISOStringToReadableDate(createdAt)}
            </Typography>
          </Stack>
          <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
            {text}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
